function isEleVisible(ele){
    var {top, right, bottom, left} = ele.getBoundingClientRect()
    var w = window.innerWidth
    var h = window.innerHeight
    if(bottom < 0 || top > h - 300){
        return false
    }
    return true
}
let hasLoadImage1 = false,
    imageList1 = [],
    hasLoadImage2 = true,
    imageList2 = [],
    //棋盘
    hasLoadImage3 = false,
    imageList3 = [];

// 加载逐帧图
function loadImage(){
    const promiseList1 = []
    for(let i = 1; i < 65; i++) {
        let promise = new Promise((resolve, reject) => {
            let img = new Image()
            img.src = `https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/s7maxv-animation1-${i}.png`
            img.onload = () => {
                resolve()
            }
            imageList1.push(img)
        })
        promiseList1.push(promise)
    }
    Promise.all(promiseList1).then(() => {
        hasLoadImage1 = true
    })

    const promiseList2 = []
    for(let i = 0; i < 80; i++) {
        let promise = new Promise((resolve, reject) => {
            let img = new Image()
            img.class='animation-image2'
            img.src = `https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/s7maxv-animation2-${i}.png`
            img.onload = () => {
                resolve()
            }
            imageList2.push(img)
        })
        promiseList2.push(promise)
    }
    Promise.all(promiseList2).then(() => {
        hasLoadImage2 = true
    })
    const promiseList3 = []
    for(let i = 1; i <= 150; i++) {
        let promise = new Promise((resolve, reject) => {
            let img = new Image()
            if(!(window.innerWidth < 750)){
                img.src = `https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/qipan${i}.png`
            }else{
                img.src = `https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/qipan-m${i}.png`
            }
            img.onload = () => {
                resolve()
            }
            imageList3.push(img)
            
        })
        promiseList3.push(promise)
    }
    Promise.all(promiseList3).then(() => {
        hasLoadImage3 = true
    })
}

loadImage();

let headerElement = document.getElementById('shopify-section-header-global')
if(!headerElement) {
    headerElement = document.getElementById('shopify-section-header')
}
let { bottom: HeaderBottom } = headerElement.getBoundingClientRect()
HeaderBottom = Math.max(HeaderBottom, 0)


$(window).on("scroll", (event) => {
    let windowInnerWidth = window.innerWidth;
    $('.section').each((index, element) => {
        if (isEleVisible(element)) {
            $(element).addClass("loaded");
        }
        var currentView = $(element).data('section')
        if(currentView == 2){
            showSecondViewAnimation(element)
        }else if(currentView == 3) {
            windowInnerWidth > 750 && showViewAnimation3(element)
        }else if (currentView == 4){
            windowInnerWidth > 750 && showViewAnimation4(element)
            windowInnerWidth <= 750 && showViewAnimation4Mobile(element)
        }else if(currentView == 5){
            showViewAnimation5(element)
        }else if(currentView == 7){
            showViewAnimation7(element)
        }else if(currentView == 8){
            showViewAnimation8(element)
        }else if(currentView == 10){
            showViewAnimation10(element)
        }
    });
});
// 刷新时初始化
let emptyWashFillDock = document.getElementById('emptyWashFillDock')
if (isEleVisible(emptyWashFillDock)) {
    $(emptyWashFillDock).addClass("loaded");
}
window.innerWidth > 750 && showViewAnimation3(emptyWashFillDock)

function showViewAnimation8 (ele){
    var {top, right, bottom, left} = ele.getBoundingClientRect()
    var height = $(ele).height()
    var percent = Math.floor(height / 5);
    if(top < 0){
        if(Math.abs(top) < 50 ){
            $(ele).find('.phone').eq(0).css('opacity',1).siblings().css('opacity',0)
        }else if(Math.abs(top) >= 50 && Math.abs(top) < percent){
            //第一个阶段
            $(ele).find('.phone').eq(1).css('opacity',1).siblings().css('opacity',0)
        }else if(Math.abs(top) >= percent && Math.abs(top) < percent * 2){
            //第二个阶段
            $(ele).find('.phone').eq(2).css('opacity',1).siblings().css('opacity',0)
            $(ele).find('.bed').eq(0).css('opacity',1).siblings().css('opacity',0)
        }else if(Math.abs(top) >= percent * 2 && Math.abs(top) < percent * 3){
            //第三个阶段
            $(ele).find('.phone').eq(3).css('opacity',1).siblings().css('opacity',0)
            $(ele).find('.bed').eq(1).css('opacity',1).siblings().css('opacity',0)
        }
        // else if(Math.abs(top) >= percent * 3 && Math.abs(top) < percent * 4){
        //     //第四个阶段
        //     $(ele).find('.phone').eq(3).css('opacity',1).siblings().css('opacity',0)
        //     $(ele).find('.bed').eq(1).css('opacity',1).siblings().css('opacity',0)
        // }
    }else{
        $(ele).find('.phone').eq(0).css('opacity',1).siblings().css('opacity',0)
    }
}

function showViewAnimation10(ele) {
    var {top, right, bottom, left} = ele.getBoundingClientRect()
    var height = $(ele).height()
    var scrollTop  = Math.abs(top)
    var windowInnerWidth = window.innerWidth;
    if(windowInnerWidth >= 750){
        if(top < 0 && scrollTop > height / 3){
            $(ele).find('.lock-img').attr('src', 'https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/lock-close.png')
            
            //$(ele).find('.privacy').css({opacity: '0'})
            $(ele).find('.privacy .mask').css({height: '60%'})
            $(ele).find('.text-content').removeClass('hide').css({
                opacity: '1',
                top:'50%'
            })
           
        }else {
            $(ele).find('.lock-img').attr('src', 'https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/lock.png')
            $(ele).find('.text-content').addClass('hide').css({
                opacity: '0',
                top:'80%'
            })
            //$(ele).find('.privacy').css({opacity: '1'})
            $(ele).find('.privacy .mask').css({height: '0'})
        }
    }else{
        $(ele).find('.lock-img').attr('src', 'https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/lock-close.png')
        $(ele).find('.privacy').css({
            height: 'auto',
            width:'auto',
        })
        $(ele).find('.privacy .text').css({
            'line-height':'1'
        })
    }
    
}
function isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
}
function showViewAnimation7(ele){
    var {top, right, bottom, left} = ele.getBoundingClientRect();
    var height = $(ele).height();
    if(hasLoadImage3){
        if(top <= 0 && bottom > 0){
            var percent = Math.floor(height / 180)
            var order = Math.ceil(Math.abs(top) / percent);
            var cHeight = document.documentElement.clientHeight,
            dHeight = $(ele).find('.section-seventh-content').height();
            $(ele).find('.section-seventh-content').css({
                top:`${(cHeight-dHeight)/2}px`
            })
            var alt = 'Roborock S7 MaxV recognizes and reacts different hazards'
            $(imageList3[order]).attr("alt",alt)
            if(order <= 150){
                
                $(ele).find('.section-seventh-content').html($(imageList3[order-1]))
            }else{
                
                $(ele).find('.section-seventh-content').html($(imageList3[149]))
            }
        }else{
            
        }
    }
}
function showViewAnimation5(ele){
    var {top, right, bottom, left} = ele.getBoundingClientRect()
    var height = $(ele).height()
    if(top < 0 && Math.abs(top) > 500){
        translateY = Math.abs(top)>500?500:Math.abs(top)
        $(ele).find('.faster-img-area.frame-img').css({
            transform:`translateY(-${translateY}px)`,
            opacity:1
        })
        if(Math.abs(top) > 550){
            $(ele).find('.faster-img-area.frame-img').css({
                transform:`translateY(-${translateY}px) scale(1.2)`,
            })
        }
    }else {
        $(ele).find('.faster-img-area.frame-img').css({
            transform:"translateY(200px)",
            opacity:0
        })
    }
}
// 移动端白天夜晚切换
function showViewAnimation4Mobile(ele){
    var imgEle = ele.querySelector('.video-img-area .img-div');
    var windowHeight = $(window).height();
    var { top } = imgEle.getBoundingClientRect()
    if(top * 2 < windowHeight - $(imgEle).height()){
        let ele = $('.video-img-area .section-sixth-bg')
        ele.attr('src', 'https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/section-sixth-bg-dark.jpg')
        $('.video-img-area .svg-area .sun-svg').css({opacity: '0.4'})
        $('.video-img-area .svg-area .moon-svg').css({opacity: '1'})
    } else {
        let ele = $('.video-img-area .section-sixth-bg')
        ele.attr('src', 'https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/section-sixth-bg.jpg')
        $('.video-img-area .svg-area .sun-svg').css({opacity: '1'})
        $('.video-img-area .svg-area .moon-svg').css({opacity: '0.4'})
    }
}

function showViewAnimation4(ele){
    var {top, right, bottom, left} = ele.getBoundingClientRect()
    var height = $(ele).height()
    var percent = height / 11;
    var translateY = $(ele).find('.faster-img-area.frame-img').height() * 0.94;
    var c = document.getElementById("section-forth-canvas");
    var ctx = c.getContext("2d");
    var frameHeight = percent * 5 / 80;
    $(ele).find('.section-wrapper').css({top: HeaderBottom/2 + 'px'})
    if(top < 0){
        // 视频初始位置
        let windowWidth = $(window).width(),
            windowHeight = $(window).height();
        // 文字正常显示
        $(ele).find('.faster-text-area').css({
            transform:`translateY(0px) scale(1.05)`,
            opacity:1
        })
        // 文字放大
        // if(Math.abs(top) > percent / 4){
        //     $(ele).find('.faster-text-area').css({
        //         transform:'translateY(0px) scale(1.3)',
        //     })
        // }
        // 机器就开始显示
        if(Math.abs(top) > percent / 2){
            $(ele).find('.faster-img-area.frame-img').css({
                transform:`translateY(-${translateY}px)`,
                opacity:1
            }).addClass('isShow')
            ctx.clearRect(0,0,c.width,c.height);
        }
        // 充电指示
        if(Math.abs(top) > percent * 2 / 3){
            $(ele).find('.lightning.circleProgress_wrapper').css({opacity: 1})
            $(ele).find('.faster-img-area.frame-img').css({
                transform:`translateY(-${translateY}px) scale(1)`
            })
            ctx.clearRect(0,0,c.width,c.height);
            ctx.beginPath();
            ctx.strokeStyle = '#43ED6F';
            ctx.lineCap = "round";
            var angle = Math.PI / 32 * Math.ceil((Math.abs(top) - percent * 2 / 3) / (percent / 64))
            ctx.lineWidth = 6;
            ctx.arc(60,60,50,-Math.PI / 2, angle - Math.PI / 2);
            ctx.stroke();
        }
        // 开始逐帧图
        if(Math.abs(top) > percent * 5 / 3){
            let count = Math.min(Math.floor((Math.abs(top) - percent * 5 / 3) / frameHeight), 79)
            if(count >= 7) {
                $(ele).find('.lightning.circleProgress_wrapper').css({opacity: 0})
                $(ele).find('.faster-text-area').css({opacity: Math.max(16 - count, 0) / 16})
            } else {
                $(ele).find('.lightning.circleProgress_wrapper').css({opacity: 1})
                $(ele).find('.faster-text-area').css({opacity: 1})
            }
            // 充电桩消失时
            if(count >= 16) {
                $(ele).find('.section-forth-title').css({opacity: 0})
                $(ele).find('.faster-text-area').css({opacity: 0})
                $(ele).find('.intelligence-area').css({opacity: 1, top: '50%'})
                $(ele).find('.intelligence-area').find('.p-desc').css({transform: 'translateY(0)', opacity: 1})
                $(ele).find('.intelligence-area').find('.intelligence-area-img').css({transform: 'translateY(0)', opacity: 1})
                $(ele).find('.section-forth-modal').css({opacity: 1})
            } else {
                $(ele).find('.section-forth-title').css({opacity: 1})
                $(ele).find('.intelligence-area').css({top: '150%'})
                $(ele).find('.intelligence-area').find('.p-desc').css({transform: 'translateY(0)'})
                $(ele).find('.intelligence-area').find('.intelligence-area-img').css({transform: 'translateY(0)'})
                $(ele).find('.section-forth-modal').css({opacity: 0})
                $(ele).find('.faster-img-area.frame-img').css({
                    transform:`translateY(-${translateY}px)`,
                    opacity:1
                }).addClass('isShow')
            }
            if(count >= 25) {
                $(ele).find('.intelligence-area').css({top: '40%'})
                $(ele).find('.intelligence-area').find('.p-desc').css({transform: 'translateY(-10vh)', opacity: 0})
                $(ele).find('.intelligence-area').find('.intelligence-area-img').css({transform: 'translateY(-10vh)', opacity: 0})
                $(ele).find('.section-forth-modal').css({opacity: 0})
            } else {
            }
            if(count >= 30) {
                $(ele).find('.text-one').css({opacity: 1})
            } else {
                $(ele).find('.text-one').css({opacity: 0})
            }
            if(count >= 40) {
                $(ele).find('.text-two').css({opacity: 1})
            } else {
                $(ele).find('.text-two').css({opacity: 0})
            }
            if(count >= 51) {
                $(ele).find('.text-three').css({opacity: 1})
            } else {
                $(ele).find('.text-three').css({opacity: 0})
            }
            if(count >= 73) {
                $(ele).find('.text-one').css({opacity: 0})
                $(ele).find('.text-two').css({opacity: 0})
                $(ele).find('.text-three').css({opacity: 0})
                $(ele).find('.intelligence-area').css({opacity: 0})
                $(ele).find('.video-wrapper').css({opacity: 1})
            } else {
                $(ele).find('.video-wrapper').css({opacity: 0})
            }
            if(count > 79) {

            }
            let alt = 'Fast Charging Roborock S7 MaxV'
            if(hasLoadImage2) {
                $(ele).find('.faster-img-area.frame-img').children().first().remove()
                if(count <= 15){
                    alt ='Fast Charging Roborock S7 MaxV'
                }else{
                    alt = 'Roborock S7 MaxV has all-knowing intelligence'
                }
                $($(imageList2[count])).attr('alt',alt)
                $(ele).find('.faster-img-area.frame-img').prepend($(imageList2[count]))
            }
        }
        let imgEle = $(ele).find('.faster-img-area.frame-img')
        var part = ele.querySelector('.faster-img-area.frame-img').getBoundingClientRect().top + imgEle.height() - windowHeight
        let bottom = $(ele).find('.faster-img-area.frame-img').height() * 0.4002 - part
        // 视频放大
        if(Math.abs(top) > percent * 5 / 3 + percent * 5){
            let videoWidth = Math.ceil(86.5 * (Math.abs(top) - percent * 5 / 3 - percent * 5) / (percent * 5 / 6)) + 13.5;
            // videoWidth = Math.min(100, videoWidth)
            if(windowWidth * videoWidth / 100 * 0.5625 < windowHeight * 1.02) {
                // 视频高度未达到全屏
                $(ele).find('.video-wrapper').css({width: videoWidth + '%'})
                $(ele).find('.video-img-area .img-div').css({width: Math.max(videoWidth, 100) + '%'})
                if(windowWidth * videoWidth / 100 * 0.5625 < windowHeight - 2 * bottom) {
                    $(ele).find('.video-wrapper').css({bottom: bottom + HeaderBottom/2 + 'px', top: 'unset'})
                } else {
                    // 视频居中
                    $(ele).find('.video-wrapper').css({bottom: 0, top: 0})
                }
            }
            // else if ($(ele).find('.video-wrapper').width() < windowWidth){
            else if (videoWidth <= 105){
                // 高度已达到100%，宽度未达到则继续放大
                $(ele).find('.video-wrapper').css({width: videoWidth + '%', bottom: 0, top: 0})
                $(ele).find('.video-img-area .img-div').css({width: Math.max(videoWidth, 100) + '%'})
            }
        } else {
            $(ele).find('.video-wrapper').css({width: '13.2%', bottom: bottom + HeaderBottom/2 + 'px', top: 'unset'})
        }
        // 视频开始播放
        if(Math.abs(top) > percent * 8 && Math.abs(top) < percent * 9) {
            if($(ele).find('.behind-video')[0].currentTime === 0){
                ele.querySelector('.behind-video').play()
            }
        } else {
            ele.querySelector('.behind-video').currentTime = 0;
            let video = ele.querySelector('.behind-video')
            !video.paused && video.pause()
        }
        // 视频变图片
        if(Math.abs(top) > percent * 9) {
            ele.querySelector('.behind-video').currentTime = 0;
            let video = ele.querySelector('.behind-video')
            !video.paused && video.pause()
            $(ele).find('.video-img-area').css({opacity: 1})
            $(ele).find('.section-sixth-title').css({transform: 'translateY(0)'})
            $(ele).find('.section-sixth-bottom').css({transform: 'translateY(0)'})
            $(ele).find('.dashed-divider span').css({top: '0'})

        } else {
            $(ele).find('.video-img-area').css({opacity: 0})
            $(ele).find('.section-sixth-title').css({transform: 'translateY(-100%)'})
            $(ele).find('.section-sixth-bottom').css({transform: 'translateY(100%)'})
        }
        // 切换白天夜晚
        if(Math.abs(top) > percent * 9.5) {
            $(ele).find('.section-sixth-bg').attr('src', 'https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/section-sixth-bg-dark.jpg')
            $(ele).find('.sun-svg').css({opacity: 0.4})
            $(ele).find('.moon-svg').css({opacity: 1})
            $(ele).find('.dashed-divider span').css({top: '84%'})
        } else {
            $(ele).find('.section-sixth-bg').attr('src', 'https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/section-sixth-bg.jpg')
            $(ele).find('.sun-svg').css({opacity: 1})
            $(ele).find('.moon-svg').css({opacity: 0.4})
        }

    }else {
        $(ele).find('.faster-img-area.frame-img').css({
            transform:"translateY(200px)",
            opacity:0
        }).removeClass('isShow')
        $(ele).find('.faster-text-area').css({
            transform:'translateY(50px) scale(1.05)'
        })
    }

}

function showViewAnimation3(ele){
    var {top, right, bottom, left} = ele.getBoundingClientRect()
    var height = $(ele).height()
    var height1 = $(window).height()
    var height2 = $(ele).find('.section-third-title').outerHeight(true)
    var height3 = $(ele).find('.section-third-content').outerHeight(true)
    if(height2 + height3 > height1) {
        $(ele).find('.section-third-container').css({position: 'relative', height: '500vh', justifyContent: 'unset'})
        $(ele).find('.section-third-wrapper').css({position: 'sticky', height: '100vh', top: HeaderBottom/2 + 'px'})
        top = top + height2
        height = height - height2
    } else {
        $(ele).find('.section-third-container').css({position: 'sticky', height: '100vh', justifyContent: 'center'})
        $(ele).find('.section-third-wrapper').css({position: 'relative', height: 'auto', top: 'unset'})
    }
    if(top <= 0 && bottom > 0 && hasLoadImage1){
        var percent = Math.floor(height / 80)
        var order = Math.max(Math.ceil(Math.abs(top) / percent), 1)
        if (order <= 16){
            $(ele).find('.content-item1').css({opacity:1}).siblings().css({opacity:0})
            $(ele).find('.animationImagePosition').css({opacity: 1})
            $(ele).find('.animationImagePosition').children().first().remove()
            $(ele).find('.animationImagePosition').prepend($(imageList1[order-1]))
        }else if(order <= 32){
            $(ele).find('.content-item2').css({opacity:1}).siblings().css({opacity:0})
            $(ele).find('.animationImagePosition').css({opacity: 1})
            $(ele).find('.animationImagePosition').children().first().remove()
            $(ele).find('.animationImagePosition').prepend($(imageList1[order-1]))
        }else if (order <= 48){
            $(ele).find('.content-item3').css({opacity:1}).siblings().css({opacity:0})
            $(ele).find('.animationImagePosition').css({opacity: 1})
            $(ele).find('.animationImagePosition').children().first().remove()
            $(ele).find('.animationImagePosition').prepend($(imageList1[order-1]))
        }else if (order <= 64){
            $(ele).find('.content-item4').css({opacity:1}).siblings().css({opacity:0})
            $(ele).find('.animationImagePosition').css({opacity: 1})
            $(ele).find('.animationImagePosition').children().first().remove()
            $(ele).find('.animationImagePosition').prepend($(imageList1[order-1]))
        } else {
            $(ele).find('.content-item4').css({opacity:1}).siblings().css({opacity:0})
            $(ele).find('.animationImagePosition').css({opacity: 1})
            $(ele).find('.animationImagePosition').children().first().remove()
            $(ele).find('.animationImagePosition').prepend($(imageList1[63]))
        }
    } else {
        if(top >= 0) {
            $(ele).find('.content-item1').css({opacity:1})
            $(ele).find('.animationImagePosition').css({opacity: 1})
            $(ele).find('.animationImagePosition').children().first().remove()
            $(ele).find('.animationImagePosition').prepend($(imageList1[0]))
        }
    }
}

function showSecondViewAnimation(ele){
    var ele = $(ele);
    // $('.stickybox').css({'position': 'fixed'});
    
    var top1 = ele.find('.content-1')[0].getBoundingClientRect().top
    var height = ele.find('.content-1')[0].getBoundingClientRect().height;
    var boundary = height/2;
    var top2 = ele.find('.content-2')[0].getBoundingClientRect().top
    var top3 = ele.find('.content-3')[0].getBoundingClientRect().top
    var top4 = ele.find('.content-4')[0].getBoundingClientRect().top
    var top5 = ele.find('.content-5')[0].getBoundingClientRect().top
    var top6 = ele.find('.content-6')[0].getBoundingClientRect().top
    function opacityData (id, num) {
          
        var Data = (height - Math.abs(num)*2) / height;
        if (Data > 0.7) {
            Data = 1;
            // ele.find('.content-'+id)
            // .addClass('fadeInUp')
            // .removeClass('fadeOutUp')
            // .css({'opacity': Data});
        } else if(Data < 0.15) {
            Data = 0;
            // ele.find('.content-'+id)
            // .addClass('fadeOutUp')
            // .removeClass('fadeInUp')
            // .css({'opacity': Data});
        };
        ele.find('.content-'+id).css({'opacity': Data});
    }
    function anim (id, num) {
        return
        if(Math.abs(num) > boundary/2){
            ele.find('.content-'+id).find('.stickybox')
            .addClass('fadeOutUp')
            .removeClass('fadeInUp')
        }else{
            ele.find('.content-'+id).find('.stickybox')
            .addClass('fadeInUp')
            .removeClass('fadeOutUp')
        }
    }

    if(top1 > -boundary && top1 < boundary){
        opacityData(1, top1)
        anim(1, top1);
    }else if (top2 > -boundary && top2 < boundary) {
        opacityData(2, top2)
        anim(2, top2);
    }else if (top3 > -boundary && top3 < boundary) {
        opacityData(3, top3)
        anim(3, top3);
    }else if (top4 > -boundary && top4 < boundary) {
        opacityData(4, top4)
        anim(4, top4);
    }else if (top5 > -boundary && top5 < boundary) {
        opacityData(5, top5)
        anim(5, top5);
    }else if (top6 > -boundary && top6 < boundary) {
        opacityData(6, top6)
        anim(6, top6);
    }
}
